import React, { ComponentType, FC, ReactNode } from 'react';
import { Container as BaseContainer, ContainerProps as GridSystemContainerProps } from 'react-grid-system';

export interface ContainerProps extends Omit<GridSystemContainerProps, 'ref'> {
  /** Content of the row. */
  children?: ReactNode;
  /** Custom element type. */
  as?: keyof JSX.IntrinsicElements | ComponentType<any>;
}

/**
 * @since 0.18.0
 * @see See the styleguide's [grid standard](/Styleguide/Grid)
 */
const Container: FC<ContainerProps> = (props) => <BaseContainer fluid {...props} />;

export default Container;
